'use strict';
module.exports = function NodeMetrics() {
	let margin = 0,
		border = 0,
		textArea = false,
		iconBox = false,
		nodeStyleWidth = 0,
		decorationsTheme = false,
		labelTextBox = false,
		standardDecorationCount = 0,
		cornerRadius = 0;
	const self = this,
		getTextBox = function () {
			if (!textArea) {
				return false;
			}
			return {
				height: textArea.height,
				width: Math.max(textArea.width, nodeStyleWidth)
			};
		},
		getContentBox = function () {
			const textBox = getTextBox();
			if (!iconBox && !textBox) {
				return {width: 0, height: 0};
			}
			if (!iconBox) {
				return getTextBox();
			} else if (!textBox) {
				return iconBox;
			}
			switch (iconBox.position) {
				case 'top':
				case 'bottom':
					return {
						height: iconBox.height + margin + textBox.height,
						width: Math.max(iconBox.width, textBox.width, nodeStyleWidth)
					};
				case 'left':
				case 'right':
					return {
						width: iconBox.width + margin + Math.max(nodeStyleWidth, textBox.width),
						height: Math.max(iconBox.height, textBox.height)
					};
				case 'center':
					return {
						height: Math.max(iconBox.height, textBox.height),
						width: Math.max(iconBox.width, textBox.width, nodeStyleWidth)
					};
				default:
					throw new Error('invalid-args');
			}
		},
		getTextPosition = function (bubble) {
			const inset = margin + border,
				textBox = getTextBox();
			if (!iconBox) {
				return {
					x: bubble.x + inset,
					y: bubble.y + inset,
					width: bubble.width - 2 * inset,
					height: bubble.height - 2 * inset
				};
			}
			if (!textArea) {
				return false;
			}
			switch (iconBox.position) {
				case 'left':
					return {
						x: bubble.x + inset + iconBox.width + margin,
						y: bubble.y + Math.round((bubble.height - textBox.height) / 2),
						width: Math.max(nodeStyleWidth, textBox.width),
						height: textBox.height
					};
				case 'right':
					return {
						x: bubble.x + inset,
						y: bubble.y + Math.round((bubble.height - textBox.height) / 2),
						width: Math.max(nodeStyleWidth, textBox.width),
						height: textBox.height
					};
				case 'top':
					return {
						x: bubble.x + inset,
						y: bubble.y + inset + iconBox.height + margin,
						width: Math.max(textBox.width, iconBox.width, nodeStyleWidth),
						height: textBox.height
					};
				case 'bottom':
					return {
						x: bubble.x + inset,
						y: bubble.y + inset,
						width: Math.max(textBox.width, iconBox.width, nodeStyleWidth),
						height: textBox.height
					};
				case 'center':
					return {
						x: bubble.x + Math.round((bubble.width - Math.max(textBox.width, iconBox.width)) / 2),
						y: bubble.y + Math.round((bubble.height - textBox.height) / 2),
						width: Math.max(textBox.width, iconBox.width, nodeStyleWidth),
						height: textBox.height
					};
				default:
					throw new Error('invalid-args');
			}
		},
		getIconPosition = function (bubble) {
			const inset = margin + border,
				textBox = getTextBox();
			if (!iconBox) {
				return false;
			}
			if (!textBox) {
				return {
					x: bubble.x + inset,
					y: bubble.y + inset,
					width: iconBox.width,
					height: iconBox.height
				};
			}
			switch (iconBox.position) {
				case 'left':
					return {
						x: bubble.x + inset,
						y: bubble.y + Math.round((bubble.height - iconBox.height) / 2),
						width: iconBox.width,
						height: iconBox.height
					};
				case 'right':
					return {
						x: bubble.x + inset + textBox.width + margin,
						y: bubble.y + Math.round((bubble.height - iconBox.height) / 2),
						width: iconBox.width,
						height: iconBox.height
					};
				case 'top':
					return {
						x: bubble.x + Math.round((bubble.width - iconBox.width) / 2),
						y: bubble.y + inset,
						width: iconBox.width,
						height: iconBox.height
					};
				case 'bottom':
					return {
						x: bubble.x + Math.round((bubble.width - iconBox.width) / 2),
						y: bubble.y + inset + textBox.height + margin,
						width: iconBox.width,
						height: iconBox.height
					};
				case 'center':
					return {
						x: bubble.x + Math.round((bubble.width - iconBox.width) / 2),
						y: bubble.y + Math.round((bubble.height - iconBox.height) / 2),
						width: iconBox.width,
						height: iconBox.height
					};
				default:
					throw new Error('invalid-args');
			}
		},
		getInsetEdgeLength = function (decorationsLength, bubbleLength, position) {
			if (position === 'center') {
				return Math.max(decorationsLength, bubbleLength);
			} else if (decorationsLength >= bubbleLength) {
				return decorationsLength + border;
			} else {
				return bubbleLength;
			}
		},
		calculateEdgeOffset = function (edgeLength, objectLength, position, inset) {
			switch (position) {
				case 'end':
					return edgeLength - objectLength - inset;
				case 'start':
					return inset;
				case 'center':
				default:
					return (edgeLength - objectLength) / 2;
			}
		},
		getBubbleAndDecorationPositions = function (bubbleBox, decorationsBox) {
			if (!decorationsBox) {
				return {
					bubble: Object.assign({x: 0, y: 0}, bubbleBox),
					width: bubbleBox.width,
					height: bubbleBox.height
				};
			}
			const bubblePosition = {x: 0, y: 0},
				decorationsPosition = {x: 0, y: 0},
				area = {width: bubbleBox.width, height: bubbleBox.height },
				decorationsOverlap = decorationsTheme.overlap ? margin : 0;

			switch (decorationsTheme.edge) {
				case 'top':
					bubblePosition.y = decorationsBox.height - decorationsOverlap;
					break;
				case 'bottom':
					decorationsPosition.y = bubbleBox.height - decorationsOverlap;
					break;
				case 'left':
					bubblePosition.x = decorationsBox.width - decorationsOverlap;
					break;
				case 'right':
					decorationsPosition.x = bubbleBox.width - decorationsOverlap;
					break;
				default:
					throw new Error('invalid-args');
			}
			switch (decorationsTheme.edge) {
				case 'top':
				case 'bottom':
					area.width = getInsetEdgeLength(decorationsBox.width, bubbleBox.width, decorationsTheme.position);
					area.height =  Math.max(bubblePosition.y + bubbleBox.height, decorationsPosition.y + decorationsBox.height);
					decorationsPosition.x = calculateEdgeOffset(
						area.width,
						decorationsBox.width,
						decorationsTheme.position, border
					);
					bubblePosition.x = calculateEdgeOffset(
						area.width,
						bubbleBox.width,
						decorationsTheme.position, 0
					);
					break;
				case 'left':
				case 'right':
					area.width = Math.max(bubblePosition.x + bubbleBox.width, decorationsPosition.x + decorationsBox.width);
					area.height = getInsetEdgeLength(decorationsBox.height, bubbleBox.height, decorationsTheme.position);
					decorationsPosition.y = calculateEdgeOffset(
						area.height,
						decorationsBox.height,
						decorationsTheme.position, border
					);
					bubblePosition.y = calculateEdgeOffset(
						area.height,
						bubbleBox.height,
						decorationsTheme.position, 0
					);
					break;
				default:
					throw new Error('invalid-args');
			}
			return {
				height: area.height,
				width: area.width,
				bubble: Object.assign(bubblePosition, bubbleBox),
				decorations: Object.assign(decorationsPosition, decorationsBox)
			};
		},
		hasDecorations = function () {
			return standardDecorationCount || labelTextBox;
		},
		boxRequiredByDecorations = function () {
			if (!hasDecorations()) {
				return false;
			}
			const widthRequiredByLabel = labelTextBox ? labelTextBox.width + 2 * (decorationsTheme.label.border + decorationsTheme.label.margin) : 0,
				spacer = standardDecorationCount && labelTextBox ? 1 : 0,
				standardDecorationWidth = decorationsTheme.height,
				standardDecorationMargin = decorationsTheme.margin,
				standardDecorationsWidth = standardDecorationCount ?  standardDecorationCount * (standardDecorationWidth + standardDecorationMargin) - standardDecorationMargin : 0;
			return {
				width: (2 + spacer) * decorationsTheme.margin + widthRequiredByLabel + standardDecorationsWidth,
				height: decorationsTheme.height + 2 * decorationsTheme.margin,
				labelWidth: widthRequiredByLabel,
				standardDecorationsWidth: standardDecorationsWidth,
				standardDecorationWidth: standardDecorationWidth,
				standardDecorationMargin: standardDecorationMargin
			};
		};
	self.requireNodeStyleWidth = function (requiredStyleWidth) {
		if (Number.isFinite(requiredStyleWidth)) {
			nodeStyleWidth = requiredStyleWidth;
		}
	};
	self.requireMargin = function (requiredMargin) {
		if (Number.isFinite(requiredMargin)) {
			margin = requiredMargin;
		}
	};
	self.requireCornerRadius = function (requiredCornerRadius) {
		if (Number.isFinite(requiredCornerRadius)) {
			cornerRadius = requiredCornerRadius;
		}
	};
	self.requireBorder = function (requiredBorder) {
		border = requiredBorder;
	};
	self.requireTextBox = function (requiredTextBox) {
		if (requiredTextBox && Number.isFinite(requiredTextBox.width) && Number.isFinite(requiredTextBox.height)) {
			textArea = {width: requiredTextBox.width, height: requiredTextBox.height};
		}
	};

	self.requireIconBox = function (requiredIconBox) {
		if (requiredIconBox && Number.isFinite(requiredIconBox.width) && Number.isFinite(requiredIconBox.height)) {
			iconBox = {width: requiredIconBox.width, height: requiredIconBox.height, position: requiredIconBox.position};
		}
	};
	self.requireDecorations = function (requiredDecorationsTheme, requiredLabelTextBox, requiredStandardDecorationCount) {
		decorationsTheme = requiredDecorationsTheme;
		labelTextBox = requiredLabelTextBox;
		standardDecorationCount = requiredStandardDecorationCount;
	};
	self.calculate = function () {
		const contentBox = getContentBox(),
			requiredByBorder = cornerRadius * 2,
			requiredByContent = {
				width: 2 * margin + contentBox.width,
				height: 2 * margin + contentBox.height
			},
			requiredByDecorations = boxRequiredByDecorations(),
			requiredByBubble = {
				width: Math.max(requiredByBorder, requiredByContent.width) + border * 2,
				height: Math.max(requiredByBorder, requiredByContent.height) + border * 2
			},
			area =  getBubbleAndDecorationPositions(requiredByBubble, requiredByDecorations); // {decorations: {x, y}, bubble: {x, y}}} //calculateTotalArea(requireDecorations, requiredByBubble),
		area.bubble.border = border;
		area.text = getTextPosition(area.bubble);
		area.icon = getIconPosition(area.bubble);
		return area;
	};

};
